module.exports = __webpack_public_path__ + "static/media/MCT-Slider-mobile-3.4fd57c88.jpg";